<template>
    <div>
      <div v-if="isGroup">
        <public-title>门店房态管理</public-title>
        <div class="load-area">
            <gcon-search @getSearchCon="getSearchCon" />
            <p v-if="StoreLists.total<=0">当前没有数据</p>
            <div v-else>
            <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
            <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
                <li class="w-50 list-item-col">
                    <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
                </li>
                <li class="w-50 list-item-col">{{Itemize.room_state_nums}}</li>
                <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
                    {{Itemize.verify | formatVar('verifyType')}}
                </li>
                <li class="w-50 list-item-col">
                    {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
                </li>
                <li class="w-50 list-item-col-end">
                    <span class="text-link" @click="goForDetail(Itemize)">查看</span>
                </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                :total="StoreLists.total" :current-page="Number(queryCon.page)"
                @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
            </div>
        </div>
      </div>
      <room-type v-else/>
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import RoomType from './RoomType'
  import GconSearch from '../GconSearch'

  export default {
    name: 'RoomTypeManage',
    components: { RoomType,GconSearch },
    data () {
        return {
            titleArr: ['门店名称','房态数量','门店认证','所在地','操作'],
            info: {}
        }
    },
    watch:{
      queryCon() { this.groupGetStoreLists({ page:this.queryCon.page, type:12,...this.info }) },
    },
    created () {
        if (this.isGroup) {
            if (this.queryCon.hasOwnProperty('page')) this.groupGetStoreLists({ page:this.queryCon.page, type:12 })
            else this.groupGetStoreLists({ page:1, type:12 })
        }
    },
    computed: {
        ...mapState(['StoreLists']),
        ...mapGetters(['storeInfo','isGroup']),
        queryCon() { return this.$route.query }
    },
    methods: {
        ...mapActions(['groupGetStoreLists']),
        goForDetail (item) {
            this.$router.push({name:'PubRoomType',query:{storeId: item.store_id,GST: item.title}})
        },
        goStoreDetail(id) {
            let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
            window.open(routeUrl.href, '_blank');
        },
        //搜索门店条件
        getSearchCon(info) {
            this.info=info;
            this.groupGetStoreLists({ page:1, type:12, ...info })
        }
    }
  }
</script>
